import { type UseControllerProps, useCustomController } from '@faceup/form'
import { FormItem } from '@faceup/ui'
import { FORM_ITEMS, FormItemType } from '@faceup/utils'
import { FileFormElement } from '../../components/FileForm/FileFormElement'

type FileInputProps = UseControllerProps

export const AFFileFormInput = (props: FileInputProps) => {
  const { formItemProps, inputProps } = useCustomController(props)

  return (
    <FormItem {...formItemProps} notClickableLabel>
      <input className='h-[0] w-[0] absolute invisible' readOnly tabIndex={-1} />
      <FileFormElement
        name={props.name}
        multiple={true}
        maxCount={FORM_ITEMS[FormItemType.File].maxFormCount}
        className='w-full'
        onChange={({ fileList }) => {
          const files = fileList.map(file => file.originFileObj as File).filter(Boolean)
          inputProps.onChange(files)
        }}
      />
    </FormItem>
  )
}
